import type { SVGProps } from 'react'

export function GoogleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false" role="img" {...props}>
      <path
        fill="#EA4335"
        d="M12 10.2v3.6h5.08A4.98 4.98 0 0 1 12 17.4a5.4 5.4 0 1 1 3.82-9.24l2.55-2.56A9 9 0 0 0 12 2.1a9.9 9.9 0 1 0 0 19.8c4.98 0 9.18-3.66 9.18-9.18 0-.66-.07-1.2-.18-1.8Z"
      />
      <path fill="#34A853" d="M4.83 14.37a5.4 5.4 0 0 1 0-4.74l-2.85-2.1a9.9 9.9 0 0 0 0 8.94z" />
      <path
        fill="#FBBC05"
        d="M12 6.6c1.35 0 2.57.48 3.52 1.26l2.55-2.57A8.97 8.97 0 0 0 12 2.1a9.9 9.9 0 0 0-9.2 5.43l2.85 2.1A5.4 5.4 0 0 1 12 6.6Z"
      />
      <path
        fill="#4285F4"
        d="M21.18 12a8.74 8.74 0 0 0-.18-1.8H12v3.6h5.08a5.16 5.16 0 0 1-2.18 3.24l3.35 2.51A9.85 9.85 0 0 0 21.18 12Z"
      />
      <path
        fill="#1A73E8"
        d="m19.25 17.55-3.35-2.51A5.34 5.34 0 0 1 12 17.4a5.4 5.4 0 0 1-4.68-2.7l-2.85 2.1A9.9 9.9 0 0 0 12 21.9c2.43 0 4.68-.84 6.4-2.25Z"
      />
    </svg>
  )
}
